import { Controller } from "@hotwired/stimulus";

/**
 * チェックの状態によって表示を切り替える
 */
class SimpleToggleController extends Controller {
  static targets = ["showIfChecked", "showUnlessChecked", "checkbox"];
  static outlets = [
    // ToggleControllerを更新する
    "toggle",
  ];

  #checked = false;

  connect() {
    if (this.hasCheckboxTarget) this.#checked = this.checkboxTarget.checked;
    this.#update();
  }

  toggle(event) {
    if (event.target.type === "checkbox") {
      this.#checked = event.target.checked;
    } else {
      this.#checked = !this.#checked;
    }
    console.debug("checked", this.#checked, event);
    this.#update();
  }

  #update() {
    // #visibleTargets を表示してinputを有効にする
    for (const target of this.#visibleTargets) {
      target.style.display = "";
      for (const input of target.querySelectorAll("input, select, textarea")) {
        input.disabled = false;
      }
    }
    // ToggleControllerにより無効にされたinputも有効になってしまっているため、再度更新してもらう
    for (const toggle of this.toggleOutlets) {
      toggle.updatePanelVisibility();
    }
    // #hiddenTargets を非表示にしてinputを無効にする
    for (const target of this.#hiddenTargets) {
      target.style.display = "none";
      for (const input of target.querySelectorAll("input, select, textarea")) {
        input.disabled = true;
      }
    }
  }

  get #visibleTargets() {
    return this.#checked ? this.showIfCheckedTargets : this.showUnlessCheckedTargets;
  }

  get #hiddenTargets() {
    return this.#checked ? this.showUnlessCheckedTargets : this.showIfCheckedTargets;
  }
}

/**
 * 1日イベントと期間イベントで開催日の表示を切り替える
 * @example
 * <div controller="event-period" data-event-period-toggle-outlet=".outlet">
 *  <input type="checkbox" data-action="event-period#toggle" data-event-period-target="checkbox">
 *  <div data-event-period-target="showUnlessChecked">
 *    1日イベント
 *    <div data-controller="toggle" class="outlet">トグル</div>
 *  </div>
 *  <div data-event-period-target="showIfChecked">期間イベント</div>
 * </div>
 */
export class EventPeriodController extends SimpleToggleController {}

/**
 * オンラインイベントの場合に表示を切り替える
 * @example
 * <div controller="event-online">
 * <input type="checkbox" data-action="event-online#toggle" data-event-online-target="checkbox">
 *  <div data-event-online-target="showIfChecked">オンラインイベント</div>
 *  <div data-event-online-target="showUnlessChecked">オフラインイベント</div>
 * </div>
 */
export class EventOnlineController extends SimpleToggleController {}
